module.exports = __webpack_public_path__ + "img/XLSX_document_icon@2x.ba5671d4.png";